import { apiUrl } from './api-config';
export async function reportScreenFailure(): Promise<string | null> {
  const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),8000);
  try {
    const token=localStorage.getItem('compostdeveloper_token');
    if(!token)return null;
    const response=await fetch(apiUrl('/api/diagnostics'),{method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${token}`},body:JSON.stringify({code:'screen_crash',platform:'web',version:'1.0.0'}),signal:controller.signal});
    if(!response.ok)return null;
    const data=await response.json();return typeof data.reference==='string'?data.reference:null;
  } catch {return null;} finally {clearTimeout(timer);}
}
